import React from 'react';
import { Card, Button, Alert, Spinner } from 'react-bootstrap';
import { CreditCard, Wrench, CheckCircle, ExclamationTriangle, CloudArrowUp } from 'react-bootstrap-icons';
import { pricingPlansSeedData } from '../../data/pricingPlansSeedData';

const DataSetup = ({ 
  setupLoading, 
  setupStatus, 
  onSeedPricingPlans, 
  onResetSetupStatus 
}) => {
  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Database Initialization</h5>
      </Card.Header>
      <Card.Body>
        <div className="row">
          <div className="col-md-6">
            <div className="setup-section mb-4">
              <h6 className="text-primary mb-3">
                <CreditCard className="me-2" />
                Pricing Plans Setup
              </h6>
              <p className="text-muted small mb-3">
                Initialize the database with enhanced pricing plans including Prime, Prime+, Elite, Elite+, Supreme, and Supreme+ plans with multiple plans support.
              </p>
              <Button 
                variant="outline-primary" 
                onClick={onSeedPricingPlans} 
                disabled={setupLoading}
                className="w-100"
              >
                {setupLoading && setupStatus.pricingPlans === 'loading' ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Seeding Pricing Plans...
                  </>
                ) : (
                  <>
                    <CloudArrowUp className="me-1" />
                    Seed Pricing Plans
                  </>
                )}
              </Button>
              
              {setupStatus.pricingPlans === 'success' && (
                <Alert variant="success" className="mt-3 mb-0">
                  <CheckCircle className="me-2" />
                  Pricing plans seeded successfully! 6 plans created.
                </Alert>
              )}
              {setupStatus.pricingPlans === 'error' && (
                <Alert variant="danger" className="mt-3 mb-0">
                  <ExclamationTriangle className="me-2" />
                  Error: {setupStatus.message}
                </Alert>
              )}
            </div>
          </div>
          
          <div className="col-md-6">
            <div className="setup-section">
              <h6 className="text-info mb-3">
                <Wrench className="me-2" />
                Reset Setup Status
              </h6>
              <p className="text-muted small mb-3">
                Clear the setup status indicators to reset the initialization state.
              </p>
              <Button 
                variant="outline-info" 
                onClick={onResetSetupStatus}
                className="w-100"
              >
                Reset Status
              </Button>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DataSetup; 